import { useState, } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { NSARouterMaker, NSARouterMakerProps } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from 'namirasoft-core';
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftNWSRegionServer } from "namirasoft-nws-region";
// Layout & Routes
import { NWSRegionLayout } from "./NWSRegionLayout";
import { NWSRegionRoutes } from "./NWSRegionRoutes";
// Pages
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegionListPage from "./pages/RegionListPage";
import RegionViewPage from "./pages/RegionViewPage";

export default function Router()
{
    let [state, setState] = useState<number>(Math.random());

    let navigate = useNavigate();

    let maker = new NSARouterMaker(
        ProductUUID.NAMIRASOFT_NWS_REGION,
        new IStorageSession(),
        () => setState(state + Math.random()),
        {
            onRenderOnLogin: (props: NSARouterMakerProps) =>
            {
                let REACT_APP_BASE_URL_NWS_REGION = new EnvService("REACT_APP_BASE_URL_NWS_REGION", true).getString();

                let nws_region = new NamirasoftNWSRegionServer(REACT_APP_BASE_URL_NWS_REGION, props.account.token_manager, props.notifier.onError);

                let servers = { nws_region };

                return (
                    <Routes>
                        <Route path={NWSRegionRoutes.Home} element={<HomePage {...props} />} />
                        <Route path={NWSRegionRoutes.RegionList} element={<RegionListPage {...props} servers={servers} />}></Route>
                        <Route path={NWSRegionRoutes.RegionView(":id")} element={<RegionViewPage {...props} servers={servers} />}></Route>
                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes>
                );
            },
            onRenderOnLogout: () => (
                <Routes>
                    <Route path={NWSRegionRoutes.Home} element={<LoginPage />} />
                    <Route path="*" element={<LoginPage />} />
                </Routes>
            ),
            renderOnNSALayout: (props, children) => (
                <NWSRegionLayout {...props}>
                    {children}
                </NWSRegionLayout>
            ),
            requirement: {
                verification: {
                    email: false,
                    phone: false
                }
            }
        },
        navigate
    );

    return maker.onRender();
}